import ShortestPathOrgNumberInput from "./ShortestPathOrgNumberInput";
import { Box, Paper, CircularProgress } from "@mui/material";
import { Outlet, useNavigation } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import PageHeader from '../../components/PageHeader';

export default function ShortestPathCompanyAssessment() {
  const navigation = useNavigation();
  const { t } = useTranslation();

  return (
    <Box sx={{ width: '100%', minWidth: 0, display: 'flex', flexDirection: 'column' }}>
      <PageHeader title={t('navigation.relationships')} description={t('ui.shortestPathDescription')} icon={<CompareArrowsIcon />} />
      <Paper variant="outlined" sx={{ p: 2, mb: 3, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2 }}>
        <ShortestPathOrgNumberInput />
        {navigation.state === 'loading' && (
          <CircularProgress size={24} aria-label={t('common.states.loading')} />
        )}
      </Paper>
      <Outlet />
    </Box>
  );
};
